import script from "./PdfPptAudio.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfPptAudio.vue?vue&type=script&setup=true&lang=js"

import "./PdfPptAudio.vue?vue&type=style&index=0&id=2ec725e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec725e4"]])

export default __exports__